export const work = [
  {
    organisation: "Singapore University of Technology and Design",
    role: "Research Assistant, Context-Aware Interaction Lab",
    duration: "Jun 2024 - Sep 2024",
    jobscope: [
      {
        description:
          "Under the Context-Aware Interaction Lab, an interdisciplinary Human-Computer Interaction research lab which focuses on sensing and understanding contexts in wellness, healthcare, and human performance to empower users using AI",
      },
      {
        description:
          "Assisted in designing and executing user studies to gather valuable insights",
      },
      {
        description:
          "Recruited and coordinated with participants to ensure smooth study execution",
      },
      {
        description:
          "Drafted Institutional Review Board (IRB) forms for new user studies",
      },
      {
        description:
          "Provided support in various research-related tasks as needed",
      },
    ],
    repeat: 0,
  },
  {
    organisation: "Changi General Hospital",
    role: "Student Attachment, Cardiology Department",
    duration: "Sep 2023 - Sep 2023",
    jobscope: [
      {
        description:
          "Shadowed Dr Colin Yeo in clinics and intervention procedures",
      },
      {
        description:
          "Observed usage of different processes and equipment used in cardiology-related interventions and procedures",
      },
    ],
    repeat: 2,
  },
  {
    organisation: "A*STAR Bioinformatics Institute",
    role: "Research Intern, Clinical Data Analytics & Radiomics Department",
    duration: "Sep 2022 - Jan 2023",
    jobscope: [
      {
        description: "Awarded the <a href=\"https://www.a-star.edu.sg/scholarships/home/student-awards/astar-research-internship-award-(aria)\" target=\"_blank\" rel=\"noopener noreferrer\" class=\"text-green dark:text-green-dark underline underline-offset-2\">A*STAR Research Internship Award (ARIA)</a>",
      },
      {
        description: "Supervised by Dr Bhanu Prakash, Principal Investigator, Clinical Data Analytics and Radiomics Department, and worked closely with Dr Arvind Srinivasa",
      },
      {
        description:
          "Conducted a comparative analysis of the classification of patients with schizophrenia and healthy controls using machine learning on Asian and Caucasian cohorts",
      },
      {
        description:
          "Identified sets of minimal features that were statistically significant and consistent with an AUC value of 0.95 and above across 3 basic classifiers",
      },
      {
        description:
          "Explored data normalisation, data preparation, and data analysis using Python and software like JMP",
      },
      {
        description:
          "Worked on deep learning tasks related to the segmentation of brown adipose tissue",
      },
      {
        description:
          "Compiled research findings using LaTeX in a manuscript, which we aim to publish in an academic journal",
      },
    ],
    repeat: 2,
  },
  {
    organisation: "Kura Kura",
    role: "Software Developer",
    duration: "Jan 2022 - Jul 2023",
    jobscope: [
      {
        description:
          "Developed frontend screens for the mobile application using React Native based on Figma mockups",
      },
      {
        description:
          "Developed a new login web screen for a dashboard component using React and Tailwind CSS for teachers to track their students’ mental wellbeing on a periodic basis",
      },
      {
        description:
          "Worked on backend calls to retrieve the data for the dashboard from an AWS EC2 server",
      },
      {
        description:
          "Set up a database for a 2-player game using Firebase’s Cloud Firestore",
      },
    ],
    repeat: 0,
  },
  {
    organisation: "Kura Kura",
    role: "R&D Lead",
    duration: "Jul 2021 - Jan 2022",
    jobscope: [
      {
        description:
          "Developed a Telegram bot using Python where users could send their feedback and bugs for beta testing",
      },
      {
        description:
          "Conceptualised games that served as preventive measures to boost mental wellness for users on the application with tenets of positive psychology",
      },
    ],
    repeat: 1,
  },
  {
    organisation: "Kura Kura",
    role: "Content Lead",
    duration: "Nov 2020 - Jul 2021",
    jobscope: [
      {
        description:
          "Researched and designed social media content for LinkedIn, Medium, Instagram on a weekly basis to improve user engagement and outreach",
      },
      {
        description:
          "Conducted customer outreach calls and generated leads for the company over 3 months, with one lead being the current psychology advisor, Eddie Chua",
      },
    ],
    repeat: 1,
  },
  {
    organisation: "SAGE",
    role: "Co-Founder and Tech Lead",
    duration: "Oct 2020 - Dec 2021",
    jobscope: [
      {
        description:
          "Developed a web application using React, Tailwind CSS and MongoDB to enable users to create their own profiles and communicate with others on the SAGE web interface",
      },
      {
        description:
          "Designed a functional prototype with user interfaces for the web application using Marvel and Figma in 3 weeks during SUTD Design Odyssey’s DRIVE Programme",
      },
      {
        description:
          "Collaborated with the Business Development and Marketing Leads to develop features for a Telegram bot that enabled users to connect with each other",
      },
      {
        description:
          "Managed 3-4 developers to develop features for the Telegram bot and web application",
      },
      {
        description:
          "1 of 2 teams to represent Singapore in YMCA’s regional RaonAtti programme, placed top 10 in the Impact through Inspiration E-Ideathon 2021, and placed in the semi-finals for SUTD’s $15k Competition",
      },
    ],
    repeat: 2,
  },
  {
    organisation: "Changi General Hospital",
    role: "Student Attachment, Otolaryngology (ENT) Department",
    duration: "Sep 2019 - Sep 2019",
    jobscope: [
      {
        description:
          "Shadowed doctors such as Prof Hsu Pon Poh in the public and private clinics to understand how they interact with and diagnose patients",
      },
      {
        description:
          "Observed usage of different processes and equipment used in ENT clinics, such as endoscopy, biopsies and ear digging",
      },
    ],
    repeat: 2,
  },
  {
    organisation: "A*STAR Institute for Infocomm Research",
    role: "Research Attachment, Deep Learning in Healthcare Department",
    duration: "May 2019 - Oct 2019",
    jobscope: [
      {
        description: "Under the <a href=\"https://www.a-star.edu.sg/scholarships/home/student-awards/astar-youth-researcher-award-(poly)\" target=\"_blank\" rel=\"noopener noreferrer\" class=\"text-green dark:text-green-dark underline underline-offset-2\">A*STAR Science Award (Polytechnic)</a>",
      },
      {
        description: "Supervised by Dr Pavitra Krishnaswamy, Principal Investigator, Deep Learning in Healthcare Department, and worked closely with Ms Guo Yang and Mr Zhengyuan Liu",
      },
      {
        description:
          "Developed a web application using React and Flask to enable evaluations of novel language technologies for improving workflow efficiencies in a hospital telehealth setting",
      },
      {
        description:
          "For the speech data component, users can submit a transcription of audio files (of a nurse-patient dialogue) in text format to be processed using the LSTM model. The results of the model will be displayed in a table. Users can also play audio files from a dropdown list and search for a specific word and display the sentence in which the word appears.",
      },
      {
        description:
          "For the structured data component, users can either enter structured data into 2 dataframes or upload files from their local directory. This will be processed by a machine learning model, and the results will be displayed in a table highlighting the most important feature and a time-series line graph showing risk levels.",
      },
    ],
    repeat: 2,
  },
];
